"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewParams = exports.supportedSRIDsFriendlyNames = exports.supportedSRIDs = exports.getTransformPointFn = exports.getProjection = void 0;
const proj4_1 = __importDefault(require("proj4"));
const proj4_2 = require("ol/proj/proj4");
const proj_1 = require("ol/proj");
const Projection_1 = __importDefault(require("ol/proj/Projection"));
const getProjection = (epsgCode) => {
    if (Object.keys(projDefinitions).includes(epsgCode)) {
        proj4_1.default.defs(epsgCode, projDefinitions[epsgCode]);
        (0, proj4_2.register)(proj4_1.default);
        const viewParams = (0, exports.getViewParams)(epsgCode);
        (0, proj_1.addProjection)(new Projection_1.default({
            code: epsgCode,
            extent: viewParams.extent,
            worldExtent: viewParams.extent,
            units: viewParams.units
        }));
    }
    return (0, proj_1.get)(epsgCode);
};
exports.getProjection = getProjection;
const getTransformPointFn = (source, destination) => source === destination
    ? (lonOrX, latOrY) => [lonOrX, latOrY]
    : (lonOrX, latOrY) => (0, proj_1.transform)([lonOrX, latOrY], source, destination);
exports.getTransformPointFn = getTransformPointFn;
exports.supportedSRIDs = {
    "3006": "SWEREF99 TM",
    "3035": "LAEA Europe",
    "4326": "WGS 84",
    "3857": "Web Mercator",
    "54030": "World Robinson",
};
exports.supportedSRIDsFriendlyNames = {
    "3006": "Sweden (SWEREF99 TM)",
    "3035": "Europe (LAEA)",
    "4326": "World (Degrees)",
    "3857": "World (Mercator)",
    "54030": "World (Robinson)",
};
const projDefinitions = {
    "EPSG:3006": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "EPSG:3035": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "EPSG:54030": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
};
const getExtent = (bBox) => [bBox[0][0], bBox[0][1], bBox[1][0], bBox[1][1]];
const getRect = (bBox) => [
    bBox[0][0], bBox[0][1],
    bBox[0][0], bBox[1][1],
    bBox[1][0], bBox[1][1],
    bBox[1][0], bBox[0][1],
    bBox[0][0], bBox[0][1]
];
const getViewParams = (epsgCode) => {
    const bBox3006 = [[190000, 6101648], [970000, 7689478]];
    const bBox4326 = [[-180, -90], [180, 90]];
    const bBox3857 = [[-20026376.39, -20048966.10], [20026376.39, 20048966.10]];
    const bBox3035 = [[1896628.618, 1330000], [7390000, 6827128]];
    const bBox54030 = [[-18e6, -9e6], [18e6, 9e6]];
    switch (epsgCode) {
        case 'EPSG:3006':
            return {
                initCenter: [609924, 6877630],
                extent: getExtent(bBox3006),
                rect: getRect(bBox3006),
                units: 'm'
            };
        case 'EPSG:4326':
            return {
                initCenter: [0, 20],
                extent: getExtent(bBox4326),
                units: 'degrees'
            };
        case 'EPSG:3857':
            return {
                initCenter: (0, proj_1.fromLonLat)([0, 20], 'EPSG:3857'),
                extent: getExtent(bBox3857),
                units: 'm'
            };
        case 'EPSG:3035':
            return {
                initCenter: [4321000, 4080000],
                extent: getExtent(bBox3035),
                rect: getRect(bBox3035),
                units: 'm'
            };
        case 'EPSG:54030':
            return {
                initCenter: [0, 0],
                extent: getExtent(bBox54030),
                units: 'm'
            };
        default:
            throw new Error('Unsupported projection: ' + epsgCode);
    }
};
exports.getViewParams = getViewParams;
